import Mock from 'mockjs'
// let responseSuccessData = Mock.mock({
//   'data|4-40': [
//     {
//       'id|+1': 1,
//       name: '@cname',
//       'gender|1': ['male', 'female'],
//       group: {
//         'title|1': ['小学组', '中学组', '高中组', '大学组'],
//         'id|+1': 1
//       },
//       subject: '@ctitle',
//       birthday: '@datetime()',
//       work_position: '@ctitle',
//       position: '@ctitle',
//       'status|1-2': true
//     }
//   ]
// })

export default [
  {
    path: '/api/getAuditList',
    type: 'get',
    response: config => {
      let responseSuccessData = Mock.mock({
        'data|4-40': [
          {
            'id|+1': 1,
            name: '@cname',
            'gender|1': ['male', 'female'],
            group: {
              'title|1': ['小学组', '中学组', '高中组', '大学组'],
              'id|+1': 1
            },
            subject: '@ctitle',
            birthday: '@datetime()',
            work_position: '@ctitle',
            position: '@ctitle',
            'status|1-2': true
          }
        ]
      })
      let paramsObj = param2Obj(config.url)
      let limit = paramsObj.page
      let size = paramsObj.per_page
      let responseData = responseSuccessData.data.slice(
        (limit - 1) * size,
        limit * size
      )
      return {
        status: 'success',
        total: responseSuccessData.data.length,
        data: responseData
      }
    }
  }
]

function param2Obj (url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}



// WEBPACK FOOTER //
// ./src/mocks/audit/audit.js